import React, { useState, useEffect } from "react";

import { Form, Input, Button, message, Table, Tag } from "antd";

import { Http } from "../../Http";
import queryString from "query-string";

import styles from "./Rank.module.less";

function Rank({ location }) {
  const { state } = location;

  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [data, setData] = useState({});
  const [search, setSearch] = useState(state.search ? state.search : {});
  const [pagination, setPagination] = useState(
    state.pagination
      ? state.pagination
      : {
          current: 1,
          pageSize: 10,
          total: 0,
        }
  );

  const [form] = Form.useForm();

  const columns = [
    {
      title: "序号",
      dataIndex: "id",
      key: "id",
      width: 100,
    },
    {
      title: "关键词",
      dataIndex: "word",
      key: "word",
      ellipsis: true,
    },
    {
      title: "搜索引擎",
      dataIndex: "engine",
      key: "engine",
      render: (value) => {
        return (
          <span>
            <Tag color={value === 1 ? null : "blue"}>百度</Tag>
            <Tag color={value === 2 ? null : "green"}>360</Tag>
            <Tag color={value === 3 ? null : "red"}>搜狗</Tag>
            <Tag color={value === 4 ? null : "orange"}>神马</Tag>
          </span>
        );
      },
    },
    {
      title: "排名",
      dataIndex: "pos",
      key: "pos",
      ellipsis: true,
      render: (value) => <span title={value}>{value}</span>,
    },
  ];

  const onSearch = (values) => {
    if (values.kw) {
      values.kw = values.kw.replace(/\s+/g, "");
    }
    setSearch(values);
    onLoading({
      search: values,
      pagination: { current: 1, pageSize: 10, total: 0 },
    });
  };

  const getRankList = async (params) => {
    let para = queryString.stringify(params);
    let parsed = await Http.get(`rank`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setData(parsed.result);
      setPagination({
        current: parsed.result.pageNumber,
        pageSize: parsed.result.pageSize,
        total: parsed.result.totalRow,
      });
    }
  };

  const onLoading = async (params) => {
    setLoading(true);
    try {
      await getRankList({
        ...params.search,
        pageNumber: params.pagination.current,
        pageSize: params.pagination.pageSize,
      });
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onLoading({ search, pagination });
  }, []);

  return (
    <div className={styles.Rank}>
      <div className={styles.header}>
        <div className={styles.headerLeft}></div>
        <div className={styles.headerRight}>
          <Form
            initialValues={search}
            form={form}
            layout="inline"
            onFinish={onSearch}
          >
            <Form.Item name="kw" style={{ width: 240 }}>
              <Input placeholder="请输入关键词" />
            </Form.Item>
            <Form.Item>
              <Button
                htmlType="reset"
                onClick={() => {
                  form.resetFields();
                }}
              >
                重置
              </Button>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      <div className={styles.content}>
        <Table
          loading={loading}
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            onChange: (srk) => {
              setSelected(srk);
            },
          }}
          onChange={(p, f, s) => {
            let sort = null;
            if (s.order) {
              sort = `${s.field} ${s.order.replace("end", "")}`;
            }
            onLoading({ search: { ...search, sort }, pagination: p });
          }}
          dataSource={data.list}
          columns={columns}
          pagination={pagination}
        />
      </div>
    </div>
  );
}
export default Rank;
